import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { registerServiceWorker } from './utils/serviceWorkerRegistration.js'

// "ResizeObserver loop completed with undelivered notifications" is a benign
// browser event fired when a ResizeObserver callback triggers a layout change
// before all notifications are delivered. Stop it from reaching PostHog.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

// Stale-deploy recovery. After a deploy, hashed chunks are renamed and the old
// ones are removed from the CDN. A client still running the previous index.html
// requests a now-missing chunk; Cloudflare Pages serves index.html (200 +
// text/html) for the missing asset, so the dynamic import fails with "Failed to
// fetch dynamically imported module" / "text/html is not a valid JavaScript MIME
// type". Vite fires `vite:preloadError` for exactly this. Reload ONCE (guarded
// against a loop) to fetch the fresh index.html + current chunk hashes.
const PRELOAD_RELOAD_KEY = 'tm.preloadReloadedAt';
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  try {
    const last = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY) || 0);
    // Only reload once per ~10s window so a genuinely-broken deploy can't loop.
    if (Date.now() - last > 10_000) {
      sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
  } catch {
    window.location.reload();
  }
});

createRoot(document.getElementById('root')).render(
  <App />
)

// Skip SW registration when the app is iframed (e.g. third-party embeds of
// /widgets/btc-trades). The SW is scoped to the tradermap.io origin, so an
// iframe registration would still install — incurring an unnecessary
// install + activate cycle per embed and desyncing widget cache behavior
// from the main app. Only register at the top of the window.
const isTopLevel = (() => {
  try { return window.top === window.self; } catch { return false; }
})()
const isWidgetPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/widgets/')
if (isTopLevel && !isWidgetPath) {
  registerServiceWorker()
}
